import React, { useState } from 'react';
import './WebshopNumericInput.css'; // Make sure to create a CSS file with the necessary styles

const WebshopNumericInput: React.FC = () => {
    const [value, setValue] = useState<number>(1);

    const decrement = () => {
        setValue(prevValue => (prevValue > 0 ? prevValue - 1 : 0));
    };

    const increment = () => {
        setValue(prevValue => prevValue + 1);
    };

    return (
        <span className="numeric-input">
            <button onClick={decrement} className="decrement-button">-</button>
            <input type="text" value={value} readOnly className="input-field" />
            <button onClick={increment} className="increment-button">+</button>
        </span>
    );
};

export default WebshopNumericInput;